import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { User } from "../components/authentication/models/authTypes";

interface ApplicationState {
  theme: "light" | "dark";
  language: string;
  queueBackendUrl: string;
  user: User;
}

const initialState: ApplicationState = {
  theme: "light",
  language: "en",
  queueBackendUrl: "",
  user: null,
};

const applicationSlice = createSlice({
  name: "application",
  initialState,
  reducers: {
    setTheme(state, action: PayloadAction<"light" | "dark">) {
      state.theme = action.payload;
    },
    setLanguage(state, action: PayloadAction<string>) {
      state.language = action.payload;
    },
    setQueueApiEndpoint(state, action: PayloadAction<string>) {
      state.queueBackendUrl = action.payload + "api/";
    },
    setUser(state, action: PayloadAction<User>) {
      if (action.payload) {
        state.user = action.payload;
      }
    },
  },
});

export const { setTheme, setLanguage, setQueueApiEndpoint, setUser } =
  applicationSlice.actions;
export default applicationSlice.reducer;
